export default class TipoAtividade {

  constructor(
    IdTipoAtividade = null,
    Descricao = '',
    Status = 'A'
  ) {
    this.IdTipoAtividade = IdTipoAtividade;
    this.Descricao = Descricao;
    this.Status = Status;
  }
  
}